import React from 'react';
import { user } from '../../../types/general-types';
import Moment from 'react-moment';
import Switch from "react-switch";
import PasswordReset from './PasswordReset';


const UserRow = ({ user, index, activo, activarDesactivarUsuario }: { user: user, index: number, activo: boolean, activarDesactivarUsuario: (activo: boolean, index: number, id: string) => void }) => {
    return (
        <tr key={index}>
            <td>{user.nombre}</td>
            <td>{user.apellido}</td>
            <td>
                <Moment format="DD/MM/YYYY">
                    {user.birthday}
                </Moment>
            </td>
            <td>
                {user.email}
            </td>
            <td>{user.documentDescription}</td>
            <td>{user.numberId}</td>
            <td>
                <Switch onChange={() => { activarDesactivarUsuario(activo, index, user.id) }} checked={activo} />
            </td>
            <td><PasswordReset userId={user.id} /></td>
        </tr>
    );
};

export default UserRow;